// configuracion de claves de acceso firebase
export const config = {
  apiKey: "AIzaSyCGpUEwfp8peeV7nCbXp5qBSgdvVXuoiMs",
  authDomain: "bingeres.firebaseapp.com",
  projectId: "bingeres",
  storageBucket: "bingeres.appspot.com",
  messagingSenderId: "771348716896",
  appId: "1:771348716896:web:f68327a188c0e612a3d205"
}
